import { render, staticRenderFns } from "./PsHomeDecreaseInPatients.vue?vue&type=template&id=df9fb0a6&scoped=true&"
import script from "./PsHomeDecreaseInPatients.vue?vue&type=script&lang=js&"
export * from "./PsHomeDecreaseInPatients.vue?vue&type=script&lang=js&"
import style0 from "./PsHomeDecreaseInPatients.vue?vue&type=style&index=0&id=df9fb0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9fb0a6",
  null
  
)

export default component.exports